import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
  animations: [
    trigger(('viewState'), [
      state('squeezed', style({
        width: 'calc(100vw - {{asideWidth}})',
        transform: 'translateX({{asideWidth}})'
      }), {params: { asideWidth: '260px'}}),
      state('pushed', style({
        width: '100%',
        transform: 'translateX({{asideWidth}})'
      }), {params: { asideWidth: '260px'}}),
      state('full', style({
        width: '100%'
      })),
      transition('pushed => full', animate('300ms ease-out')),
      transition('full => pushed', animate('300ms ease-in')),
      transition('squeezed => full', animate('300ms ease-out')),
      transition('full => squeezed', animate('300ms ease-in'))
    ])
  ]
})
export class MainContentComponent implements OnInit {
  @ViewChild('mainContent') mainContentElementRef: ElementRef;
  asideOpen: string;
  asideWidth: string;
  overlay = false;
  overlayClickAction: any;

  constructor() { }

  ngOnInit() { }

  scrollToTop() {
    if (this.mainContentElementRef) {
      this.mainContentElementRef.nativeElement.scrollTop = 0;
    }
  }

  onOverlayClick() {
    this.overlayClickAction();
    this.overlay = false;
    this.asideOpen = 'full';
  }
}
